// ABOUTME: Utility for haptic feedback on mobile devices
// This provides subtle vibration feedback for user interactions

/**
 * Triggers haptic feedback if available on the device
 * Falls back gracefully on devices without vibration support
 * @param duration Duration in milliseconds (default 10ms)
 */
export const triggerHaptic = (duration: number = 10) => {
  if ('vibrate' in navigator) {
    try {
      navigator.vibrate(duration);
    } catch (error) {
      // Silently fail if vibration is not supported or blocked
    }
  }
};

/**
 * Different haptic patterns for various interactions
 */
export const hapticPatterns = {
  light: () => triggerHaptic(10),
  medium: () => triggerHaptic(20),
  heavy: () => triggerHaptic(30),
  success: () => navigator.vibrate?.([10, 30, 10]),
  error: () => navigator.vibrate?.([50, 100, 50]),
  warning: () => navigator.vibrate?.([30, 50, 30])
};
